import "controllers";
import "manage/scout_template_offer_select_modal";
